module.exports = "/assets/c73276083b9a2c95c6622c639abd9db4.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/SY.png
// module id = 1838
// module chunks = 0